import { type DBSchemaBuilder, f } from '@toeverything/infra';

export const USER_DB_SCHEMA = {
  editorSetting: {
    key: f.string().primaryKey(),
    value: f.string(),
  },
  /**
   * Account-level ("shared") template library. Metadata only — the block
   * content of each template lives in its own userspace doc, see
   * `modules/account-template/store/content.ts`.
   */
  accountTemplate: {
    id: f.string().primaryKey(),
    name: f.string(),
    icon: f.string().optional(),
    createdAt: f.number(),
    updatedAt: f.number(),
    primaryMode: f.string().optional(),
    properties: f.json<Record<string, unknown>>().optional(),
    sourceWorkspaceId: f.string().optional(),
    sourceDocId: f.string().optional(),
    contentVersion: f.number().optional(),
    contentSize: f.number().optional(),
    blobCount: f.number().optional(),
  },
} as const satisfies DBSchemaBuilder;
export type UserDbSchema = typeof USER_DB_SCHEMA;
